import bremen from "./images/2_.jpg";
import wembley from "./images/wembley.webp";
import kanton from "./images/kanton-banner2.jpg";
import sinpar from "./images/sinpar2.jpg";
import coltec from "./images/coltec2.jpg";
import interquim from "./images/interquim.jpg";
import einhell from "./images/einhell-logo.png";
import kwb from "./images/kwb.png";

const navList =[
	{id:"1", name:"Bremen", value:"Bremen", image:`${bremen}`},
	{id:"2", name:"Wembley", value:"Wembley", image:`${wembley}`},
	// {id:"5", name:"Coltec", value:"Coltec", image:`${coltec}`},
	{id:"4", name:"Sinpar", value:"Sinpar", image:`${sinpar}`},
	// {id:"7", name:"Einhell", value:"Einhell", image:`${einhell}`},
	// {id:"8", name:"KWB", value:"KWB", image:`${kwb}`},
	{id:"3", name:"Kanton", value:"Kanton", image:`${kanton}`},
	// {id:"6", name:"Interquim", value:"Interquim", image:`${interquim}`},
      ]
export {navList}
